import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import GridContainer from '../../../../@jumbo/components/GridContainer';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import AppSelectBox from '../../../../@jumbo/components/Common/formElements/AppSelectBox';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
import { clearCurrentRelation, createRelation, updateRelation } from 'redux/actions/RelationManager';

const sourceTypeOption = [{ sourceType: 'ببین', sourceTypeId: 'bebin' }];

const CreateRelationFrom = ({ relation, movieId }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { id, source_type, target, movie_id } = relation || {};

  const [sourceType, setSourceType] = useState(source_type || 'bebin');
  const [targetLink, setTargetLink] = useState(target || '');

  const handleSubmit = () => {
    const relation = {
      movie_id: movieId || movie_id,
      source_type: sourceType,
      target: targetLink,
    };
    if (id) {
      dispatch(updateRelation({ relation, id, movieId }, history));
    } else {
      dispatch(createRelation({ relation, movieId }, history));
    }
  };

  const handleClose = () => {
    dispatch(clearCurrentRelation());
    history.push(`/relation-managment/?movie=${movieId}`);
  };

  return (
    <React.Fragment>
      <GridContainer style={{ marginBottom: 12 }}>
        <Grid item xs={12} sm={4}>
          <AppSelectBox
            fullWidth
            data={sourceTypeOption}
            label="انتخاب سرویس"
            valueKey="sourceTypeId"
            variant="outlined"
            labelKey="sourceType"
            value={sourceType}
            onChange={e => setSourceType(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <AppTextInput
            fullWidth
            variant="outlined"
            label="آدرس URL"
            value={targetLink}
            onChange={e => {
              setTargetLink(e.target.value);
            }}
          />
        </Grid>
      </GridContainer>
      <Box display="flex" justifyContent="flex-end" mb={4}>
        <Button onClick={handleClose}>لغو</Button>
        <Box ml={2}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            ثبت اطلاعات
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default CreateRelationFrom;
